<template>
  <div class="bind-mini-program">
    <el-row gutter="12">
      <el-col span="8" offset="4">
        <el-card class="bind-exists-mini-program">
          <i class="el-icon-connection"></i>
          <el-tooltip :disabled="!!componentAuthURL" class="item" effect="light" content="关联了应用的用户才可绑定小程序" placement="top-end">
            <el-link :disabled="!componentAuthURL" :href="componentAuthURL">
              <el-button :disabled="!componentAuthURL" type="primary">已有小程序，立即绑定</el-button>
            </el-link>
          </el-tooltip>
          <p class="hint">为保证所有功能的正常使用，</p><p class="hint">授权时请把所有的权限同意授权给微站</p>
        </el-card>
      </el-col>
      <el-col span="8">
        <el-card class="apply-new-mini-program">
          <i class="el-icon-edit-outline"></i>
          <el-button @click="handleClickApplyNewMiniProgram">没有小程序，立即申请</el-button>
          <p class="hint">请在微信公众平台申请新的小程序，</p><p class="hint">成功后再到微站进行绑定</p>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="cautions">
      <el-col span="8" offset="4">
        <el-card>
          <el-button @click="handleClickCautions"><i class="el-icon-info"></i>小程序绑定注意事项</el-button>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';
  import _ from 'lodash';

  @Component
  export default class BindWechat extends Vue {
    componentAuthURL = ''

    async mounted() {
      const currentApplciation = _.get(this.$root.user, 'current_role.application');
      if (currentApplciation) {
        const { url } = await this.$request.get('wechat_third_party_platform/base/component_auth_url');
        this.componentAuthURL = url;
      }
    }

    handleClickApplyNewMiniProgram() {
      this.$router.push({ name: 'apply_new_mini_program' })
    }

    handleClickCautions() {
      this.$router.push({ name: 'bind_exists_mini_program.cautions' })
    }
  }
</script>

<style lang="scss">
  .bind-mini-program {
    text-align: center;

    .el-row {
      margin-top: 100px;
      .el-button {
        padding: 15px 30px;

        span {
          font-size: 15px;
        }
      }

      .hint {
        color: #adadad;
      }
    }

    .el-icon-connection, .el-icon-edit-outline {
      font-size: 150px;
      font-weight: 500;
      display: block;
      color: #8a8a8a;
    }

    .el-card {
      text-align: center;
    }

    .apply-new-mini-program {
      .el-button > span {
        color: $primary;
      }
    }

    .cautions {
      margin-top: 50px;

      .el-button {
        width: 100%;
      }
    }
  }
</style>
